// extracted by mini-css-extract-plugin
module.exports = {"BasketBtnHolder":"SendToBasket_BasketBtnHolder__FopMg"};